import api from '@/config/axios';
import { firstAllowedPath } from '@/utils/accessControl';

export function landingForUser(user) {
  if (user.company_active === false) return '/payment';
  const journey = user.onboarding;
  if (journey?.eligible && ['pending', 'in_progress'].includes(journey.status)) return '/onboarding';
  return firstAllowedPath(user.allowed_pages);
}

export async function authenticatedLanding() {
  const { data } = await api.axios.get('/api/user');
  return landingForUser(data);
}

export function apiError(error, fallback) {
  const data = error.response?.data;
  return Object.values(data?.errors || {}).flat()[0] || data?.message || (typeof data === 'string' ? data : fallback);
}
